export interface ITravelDetails {
	reasonForTravel?: ReasonForTravel;
}

export enum ReasonForTravel {
	Business = 'business',
	Leisure = 'leisure',
}
